import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryLocationReport'
import Component from 'components/Reports/InventoryLocationReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryLocationReport })(Component)
